var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMcIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "euro_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M15,18.5A6.48,6.48,0,0,1,9.24,15h5.14a.977.977,0,0,0,.89-.55h0A1,1,0,0,0,14.38,13H8.58a6.29,6.29,0,0,1,0-2h5.8a.977.977,0,0,0,.89-.55h0A.994.994,0,0,0,14.38,9H9.24a6.5,6.5,0,0,1,9.18-2.53,1.268,1.268,0,0,0,1.57-.16h0a1.251,1.251,0,0,0-.25-1.96A8.994,8.994,0,0,0,6.52,9H3.62a1,1,0,0,0-.9.55h0A1,1,0,0,0,3.62,11H6.06a8.363,8.363,0,0,0,0,2H3.62a.977.977,0,0,0-.89.55h0A.994.994,0,0,0,3.62,15h2.9a8.994,8.994,0,0,0,13.22,4.65,1.266,1.266,0,0,0,.24-1.97h0a1.254,1.254,0,0,0-1.57-.15A6.375,6.375,0,0,1,15,18.5Z",
    fill: "#f9b000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcIcon);
export default __webpack_public_path__ + "static/media/mc-icon.a9aafe407893f5e3c762e80e8c6a32c7.svg";
export { ForwardRef as ReactComponent };